export enum LabelColor {
  Gray = 'gray',
  Orange = 'orange',
  Blue = 'blue',
  Green = 'green',
  Red = 'red',
  Teal = 'teal',
  Purple = 'purple',
  Pink = 'pink',
  Brown = 'brown',
}

export enum LabelStyle {
  Filled = 'filled',
  Outlined = 'outlined',
}

export enum LabelEntityType {
  EmailCampaign = 'email-campaign',
  ScheduledEmailCampaign = 'scheduled-email-campaign',
  SMSCampaign = 'outbound-session',
  ScheduledSMSCampaign = 'message-ics',
}

export interface CreateLabelRequestBody {
  name: string
  color: LabelColor
  style: LabelStyle
}

export interface AttachLabelRequestBody {
  labelId: string
  entityId: string
  entityType: LabelEntityType
}

export interface DetachLabelRequestBody extends AttachLabelRequestBody {
  // When attachmentsCount is 1, we need to detach with detachFromAll = true for fully deleting the label.
  detachFromAll: boolean
}

export interface LabelAttachmentsCountResponse {
  count: number
}

export interface LabelColorValue {
  color: LabelColor
  style: LabelStyle
}

export interface LabelValue {
  id: string
  name: string
}

export const LABEL_NAME_MAX_LENGTH = 50
